/* eslint-disable import/first */
import React, { useCallback, useEffect } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { useNavigate } from '@reach/router';
import { useIntl } from 'react-intl';
import ClassNames from 'classnames';
import { RiShoppingCartLine } from '@react-icons/all-files/ri/RiShoppingCartLine';
const { cartItems } = Slices.cartSlice;
import { viewCartButtonViewGA, viewCartClickGA, viewCartLoadGA } from 'spwa-ui-library/esm/utils/helperGA';
const { selectDesktop } = Slices.appSlice;
import EmptyCart from '../EmptyCart';
import css from './index.module.scss';

function CartButton({ isFloating = true }) {
  const intl = useIntl();
  const cartItemList = useSelector(cartItems);
  const countOfItems = cartItemList.reduce((a, { qty }) => a + qty, 0);
  const cartURL = `/${intl.locale}/cart`;

  const isDesktop = useSelector(selectDesktop);
  const navigate = useNavigate();
  const gotToCart = useCallback(
    (event, count) => {
      event.preventDefault();
      navigate(cartURL);
      if (countOfItems !== 0) {
        viewCartClickGA(countOfItems);
        viewCartButtonViewGA(countOfItems);
      }
    },
    [cartURL, countOfItems, navigate]
  );

  useEffect(() => {
    if (countOfItems !== 0) {
      viewCartLoadGA(countOfItems);
    }
  }, [countOfItems]);

  if (!countOfItems)
    return isDesktop && <EmptyCart isFloating={isFloating} countOfItems={countOfItems} />;
  return (
    <a
      href={cartURL}
      className={ClassNames(css.root, { [css.floating]: isFloating })}
      onClick={(event) => gotToCart(event, countOfItems)}
    >
      <RiShoppingCartLine className={css.cartIcon} />
      <div className={css.cartCount}>{countOfItems}</div>
    </a>
  );
}

export default CartButton;
